import { motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LINKS } from "@/data/content";
import { fadeUp } from "@/lib/motion";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="bg-navy text-white py-14 sm:py-20">
    <motion.div
      {...fadeUp}
      className="mx-auto max-w-3xl px-5 text-center sm:px-8"
    >
        <div className="flex flex-col items-center">
          <div>
            <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Let's Talk Hiring</h2>
            <p className="mt-4 font-heading text-lg font-semibold sm:text-xl text-white/90">Ready for a recruiting partner who shows up when it counts?</p>
            <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-white/75">
              Book a no-pressure consultation with Kelly. We'll talk through your hiring goals and whether PKR is the right fit.
            </p>
          </div>
          <Button asChild data-testid="final-cta-calendly" className="mt-8 h-12 w-fit bg-white px-6 text-base text-navy hover:bg-mist active:scale-95">
            <a href={LINKS.calendly} target="_blank" rel="noopener noreferrer">
              <CalendarCheck className="mr-2 h-5 w-5" /> Work with PKR
            </a>
          </Button>
        </div>
    </motion.div>
  </section>
);
